var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.519,
    height: 31.346,
    viewBox: "0 0 26.519 31.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(-30 -99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M131.345,264.311a25.193,25.193,0,0,1-8.81-1.513,8.534,8.534,0,0,1-3.338-2.115,3.594,3.594,0,0,1-1-2.6,13.115,13.115,0,0,1,3.786-9.08,1.22,1.22,0,0,1,1.8-.118,1.2,1.2,0,0,1-.055,1.776,10.728,10.728,0,0,0-3,6.024c-.062.409-.065.825-.116,1.236a1.531,1.531,0,0,0,.594,1.391,7.289,7.289,0,0,0,2.488,1.371,23.879,23.879,0,0,0,9.159,1.174,20.175,20.175,0,0,0,6.371-1.185,13.94,13.94,0,0,0,2.166-1.11,1.861,1.861,0,0,0,.911-1.913,10.917,10.917,0,0,0-3.106-6.962,1.332,1.332,0,0,1-.474-1.1,1.151,1.151,0,0,1,.78-1.018,1.164,1.164,0,0,1,1.308.315,13.111,13.111,0,0,1,3.164,5.016,14.058,14.058,0,0,1,.74,4.016,3.8,3.8,0,0,1-1.332,3.1,10.262,10.262,0,0,1-3.839,2.082A26.7,26.7,0,0,1,131.345,264.311Z",
    transform: "translate(-88.197 -133.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M174.574,94.208a8.436,8.436,0,1,1-8.443,8.38A8.434,8.434,0,0,1,174.574,94.208Zm-.033,14.459a6.024,6.024,0,1,0-6-6.067A6.027,6.027,0,0,0,174.541,108.667Z",
    transform: "translate(-131.309 4.792)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountProblem);
export default __webpack_public_path__ + "static/media/account_problem.9cbd7fdcc357a0d9c090841e26d40f24.svg";
export { ForwardRef as ReactComponent };